import { ApiConfig } from './api';
import { fetchWrapper, objectToSearchParams } from './utils/http-utils';
import {
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  CustomerPortalRequest,
  CustomerPortalResponse,
  SubscriptionResponse,
} from '../types/billing';

export const createCheckoutSession =
  (config: ApiConfig) =>
  (data: CheckoutSessionRequest): Promise<CheckoutSessionResponse> =>
    fetchWrapper<CheckoutSessionResponse>(
      `${config.endpoint}billing/checkout-session`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );

export const createCustomerPortal =
  (config: ApiConfig) =>
  (data: CustomerPortalRequest): Promise<CustomerPortalResponse> =>
    fetchWrapper<CustomerPortalResponse>(
      `${config.endpoint}billing/customer-portal`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      config
    );

export const getSubscription =
  (config: ApiConfig) =>
  (params: { project: string }): Promise<SubscriptionResponse> => {
    const searchParams = objectToSearchParams(params);
    return fetchWrapper<SubscriptionResponse>(
      `${config.endpoint}billing/me/subscription?${searchParams}`,
      {
        method: 'GET',
      },
      config
    );
  };

export const getSubscriptionHistory =
  (config: ApiConfig) =>
  (userId: number, params: { project: string }): Promise<SubscriptionResponse[]> => {
    const searchParams = objectToSearchParams(params);
    return fetchWrapper<SubscriptionResponse[]>(
      `${config.endpoint}admin/users/${userId}/subscriptions?${searchParams}`,
      {
        method: 'GET',
      },
      config
    );
  };
